// The flags the SPA reads to show a feature (`GET /api/v1/features`), the same for every team and
// for the page's life: read once. Until it is read, or if it fails, a feature is off.
import { useGetFeatures } from "../api/generated/endpoints/platform/platform";

const ONCE = { query: { staleTime: Number.POSITIVE_INFINITY, retry: false } } as const;

/** Spec S3: the library's search is semantic; off, the words match names. */
export function useSemanticSearch(): boolean {
  return useSemanticSearchFlag() === true;
}

/**
 * The same flag, or `undefined` while it is first read: a page whose first read depends on it (the
 * library opened with words in its link) waits for it, rather than read the other way and throw
 * that away (spec S3, decision 8). A failed read is off, as above.
 */
export function useSemanticSearchFlag(): boolean | undefined {
  const read = useGetFeatures(ONCE);
  return read.isPending ? undefined : read.data?.semantic_search === true;
}

/**
 * Spec platform/mcp-oauth: Claude.ai and ChatGPT sign in to the MCP server by OAuth, so the MCP
 * Server page's cards for them are live and Settings lists the apps connected that way; off, the
 * cards are Coming soon and Settings shows no connections.
 */
export function useMcpOAuth(): boolean {
  return useGetFeatures(ONCE).data?.mcp_oauth === true;
}
